module.exports = "/img/cj-hol_wizdome_logo.png?ddd96780da5095cc181ddc09d99ec6bb";